import type { CustomTypedTFunction } from "#modules/localization/translations"

import { z } from "zod"

export function forgotPasswordDto(t: CustomTypedTFunction<"forms", "forms" | "page/forgotPassword">) {
  // @compiler useTranslation("forms", "page/forgotPassword")

  return z.object({
    email: z.string({ required_error: t("formErrors.emailNotValid") }).email(t("formErrors.emailNotValid")),
  })
}
